import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useAccumulationCodeList from "./hooks/useAccumulationCodeList";

const AccumulationCodeList = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectModeParamData = null,
  onNavigate,
}) => {
  const accumulationCodeListData = useAccumulationCodeList(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectModeParamData,
    onNavigate
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={accumulationCodeListData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {accumulationCodeListData.screen_title} -{" "}
          <span className="heading-cod">
            {accumulationCodeListData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={accumulationCodeListData.formFields}
        paramsData={accumulationCodeListData.paramsData}
        updataParamData={accumulationCodeListData.updateParamData}
      />
      <ButtonsSection ctaButtons={accumulationCodeListData.ctaButtons} />
      <DisplayTable
        selectMode={accumulationCodeListData.selectMode}
        data={accumulationCodeListData.data}
        parmKey={accumulationCodeListData.parmKey}
        menuOptions={accumulationCodeListData.menuOptions}
        tableHeaders={accumulationCodeListData.columnDef}
        setRowData={accumulationCodeListData.setRowData}
        selectedPriceSchedules={accumulationCodeListData.selectedRows}
        setSelectedPriceSchedules={accumulationCodeListData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={accumulationCodeListData.first}
          rows={accumulationCodeListData.rows}
          totalRecords={accumulationCodeListData.totalRecords}
          currentPage={accumulationCodeListData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={accumulationCodeListData.onPageChange}
        />
      </div>
      {accumulationCodeListData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={accumulationCodeListData.isConfirmationModalOpen}
          onRequestClose={accumulationCodeListData.closeConfirmationModal}
          onBack={accumulationCodeListData.closeConfirmationModal}
          onSave={accumulationCodeListData.deleteAccumulationCode}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={accumulationCodeListData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default AccumulationCodeList;
